import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';
import ArticleCard from '@/components/feature/ArticleCard';

export default function LatestArticles() {
  const recentArticles = articles.slice(0, 4);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">影视资讯</h2>
            <p className="text-sm text-foreground-600 mt-1">最新影视动态与深度评析</p>
          </div>
          <Link
            to="/article/1"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 flex items-center gap-1 whitespace-nowrap"
          >
            更多文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="flex flex-col gap-4">
          {recentArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}